module.exports = __webpack_public_path__ + "static/media/swimmy-creation-mobile.efd08616.png";